import React from 'react';

const GoldExchangeFormModal = React.lazy(() => import('../components/FormModal'));
const goldExchangeModalRegistry = {
    company_goldExchangeId: GoldExchangeFormModal
};
export default goldExchangeModalRegistry;
